import { ArrowLeftRight, Gem } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

import { MANAGE } from './manage';

export const platformDiamondsTour = defineTour({
  id: 'platform.diamonds',
  version: 1,
  group: 'catalogue-data',
  route: '/_authed/diamonds',
  scope: 'org',
  search: { tab: 'stones' },
  icon: Gem,
  steps: [
    { id: 'intro', kind: 'intro' },
    { id: 'stones', kind: 'explain', target: 'platform.diamonds.stones', placement: 'top' },
    { id: 'filters', kind: 'explain', target: 'platform.diamonds.filters' },
    { id: 'import', kind: 'explain', target: 'platform.diamonds.import', requires: MANAGE },
    { id: 'suppliers-tab', kind: 'action', target: 'platform.diamonds.suppliers-tab' },
    { id: 'suppliers', kind: 'explain', target: 'platform.diamonds.suppliers', placement: 'top' },
  ],
  related: ['platform.exchange-rates'],
});

export const platformExchangeRatesTour = defineTour({
  id: 'platform.exchange-rates',
  version: 1,
  group: 'catalogue-data',
  route: '/_authed/exchange-rates',
  scope: 'org',
  icon: ArrowLeftRight,
  steps: [
    {
      id: 'list',
      kind: 'explain',
      variants: [
        { target: 'platform.exchange-rates.table' },
        { target: 'platform.exchange-rates.empty', copy: 'empty' },
      ],
    },
    {
      id: 'source',
      kind: 'explain',
      target: 'platform.exchange-rates.source',
      optional: true,
      waitMs: 1000,
    },
    { id: 'upsert', kind: 'explain', target: 'platform.exchange-rates.upsert', requires: MANAGE },
  ],
  related: ['platform.diamonds'],
});
